import { render, staticRenderFns } from "./tinyEditor.vue?vue&type=template&id=20d8d7dc&scoped=true&"
import script from "./tinyEditor.vue?vue&type=script&lang=js&"
export * from "./tinyEditor.vue?vue&type=script&lang=js&"
import style0 from "./tinyEditor.vue?vue&type=style&index=0&id=20d8d7dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d8d7dc",
  null
  
)

export default component.exports